module.exports = __webpack_public_path__ + "static/media/(000258).bdf2b409.jpg";